/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './BaseBonusInfoTable.scss'

import { RESERVE_PARAMETERS_TYPES, RESERVE_TYPES } from 'constants'

const getLineBreak = (isEnabled = true) => (isEnabled ? <br/> : ' ')

export const RESERVE_LEVEL = (isLineBreakEnabled) => (
    <FormattedMessage
        id='reserve_info_table.column_title.reserve_level'
        defaultMessage='Уровень{lineBreak}резерва'
        values={{
            lineBreak: getLineBreak(isLineBreakEnabled),
        }}
    />
)

export const ADDITIONAL_INDUSTRIAL_RESOURCE = (isLineBreakEnabled) => (
    <FormattedMessage
        id='reserve_info_table.column_title.additional_industrial_resource'
        defaultMessage='Дополнительный{lineBreak}промресурс'
        values={{
            lineBreak: getLineBreak(isLineBreakEnabled),
        }}
    />
)

export const RESERVES_PARAMETERS_CAPTIONS = {
    [RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS]: (
        <FormattedMessage
            id='reserve_info_table.column_title.reserve_parameters.common_area_radius'
            defaultMessage='Радиус действия'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR]: (
        <FormattedMessage
            id='reserve_info_table.column_title.reserve_parameters.crew_roles_factor'
            defaultMessage='Бонус к специальности экипажа'
        />
    ),
    [RESERVE_PARAMETERS_TYPES.MAX_DAMAGE]: (
        <FormattedMessage
            id='reserve_info_table.column_title.reserve_parameters.max_damage'
            defaultMessage='Максимальный{lineBreak}урон {asterisk}'
            values={{
                lineBreak: getLineBreak(),
                asterisk: (
                    <span className={styles.asterisk}>{'*'}</span>
                ),
            }}
        />
    ),
    [RESERVE_PARAMETERS_TYPES.AREA_RADIUS]: (
        <FormattedMessage
            id='reserve_info_table.column_title.reserve_parameters.area_radius'
            defaultMessage='Радиус{lineBreak}зоны поражения'
            values={{
                lineBreak: getLineBreak(),
            }}
        />
    ),
}

export const FOOTER_RESERVES_NOTES = {
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='reserve_info_table.footer.artillery_strike_note'
            defaultMessage='{asterisk} для боёв на VI / VIII / X уровне техники'
            values={{
                asterisk: (
                    <span className={styles.asterisk}>{'*'}</span>
                ),
            }}
        />
    ),
}



// WEBPACK FOOTER //
// ./components/BaseBonusInfoTable/translations.jsx